export const config = {
  api: {
    baseUrl: process.env.REACT_APP_API_BASE_URL || '',
    timeout: 10000,
  },
  supabase: {
    url: process.env.REACT_APP_SUPABASE_URL || '',
    anonKey: process.env.REACT_APP_SUPABASE_ANON_KEY || '',
  },
  app: {
    name: 'Plenty of Hearts',
    version: process.env.REACT_APP_VERSION || '1.0.0',
    environment: process.env.NODE_ENV || 'development',
  },
  dev: {
    // Development bypass mode - set REACT_APP_BYPASS_AUTH=true in .env to enable
    bypassAuth: process.env.REACT_APP_BYPASS_AUTH === 'true' && process.env.NODE_ENV === 'development',
    // Mock credentials mode — PERMANENTLY OFF.
    //
    // This used to read REACT_APP_MOCK_CREDENTIALS, and unlike bypassAuth above
    // it had no `NODE_ENV === 'development'` guard. The variable was set to
    // "true" on Vercel across Development, Preview AND Production, so every
    // "if (config.dev.mockCredentials) allow access without authentication"
    // branch — in SocialFeed, MobileFeedWrapper, ProfileView, ProtectedRoute
    // and Registration — was live on the public site.
    //
    // With real staging and production credentials there is no longer any need
    // for mock mode, so it is hardcoded false rather than left switchable: an
    // auth bypass that can be re-enabled by setting an environment variable is
    // one deploy away from being enabled again.
    mockCredentials: false as boolean,
    mockUser: {
      id: 'dev-user-123',
      email: 'dev@plentyofhearts.com',
      user_metadata: {
        role: 'user',
        persona: 'adventurer',
        display_name: 'Dev User',
      },
      app_metadata: {
        provider: 'email',
      },
      created_at: new Date().toISOString(),
    },
  },
};
